<template lang="pug">
    v-app-bar(:color='colorTheme' dense dark fixed clipped-left app)
        v-app-bar-nav-icon(@click.stop="toggleDrawer")
        v-toolbar-title
          v-img(:src="require('../../public/ipermitLogo.png')")
        v-spacer
        v-toolbar-title Hi, {{ this.$store.state.dataUsers.name }} &nbsp;
        v-menu(:nudge-width="170" :nudge-left='170' :nudge-bottom='40')
          template(v-slot:activator="{ on }")
              v-btn(dark icon v-on="on")
                v-icon mdi-dots-vertical
          v-list
            v-list-item(v-if="dataUsers.isAdmin" to='/user-list')
              v-list-item-action
                v-icon assignment_ind
              v-list-item-title User List
            v-list-item(to='/logout')
              v-list-item-action
                v-icon exit_to_app
              v-list-item-title Logout
</template>

<script>
import { mapMutations, mapState } from "vuex";
export default {
  name: "Toolbar",
  props: {
    title: String
  },
  methods: {
    ...mapMutations(["toggleDrawer"])
  },
  computed: {
    ...mapState(['dataUsers']),
    colorTheme: function() {
      return "#ed1b24";
    }
  }
};
</script>

<style>
</style>